import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { Link, LinkProps } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
const DocumentLink: FC<LinkProps> = ({
  children,
  ...props
}) => <NewCardLink {...props}>{children}</NewCardLink>;
export default DocumentLink;
const _exp = /*#__PURE__*/() => Link;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primaryLink;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.primaryLinkHover;
const NewCardLink = withTheme(/*#__PURE__*/styled(_exp())({
  name: "NewCardLink",
  class: "najc4lq",
  propsAsIs: true,
  vars: {
    "najc4lq-0": [_exp2()],
    "najc4lq-1": [_exp3()]
  }
}));

require("./DocumentLink.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./DocumentLink.tsx");